import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Gift, Check, Quote } from 'lucide-react';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/3Gaq57BKCUtTjyUKZsJ5YX/Bono_1.png',
  scale: 1.45,
  label: 'Bono #1',
  title: 'Reset 50+: De Agotada a Encendida en 72 Horas',
  description: 'Los primeros tres días lo cambian todo. Esta guía te dice exactamente qué hacer desde el momento en que abres el plan — para que no te quedes paralizada sin saber por dónde empezar.',
  bullets: ['Una secuencia clara para los primeros 3 días', 'Acciones simples que no requieren energía extra', 'Un punto de partida que se siente alcanzable desde el día uno'],
  quote: 'El primer paso no tiene que ser perfecto. Solo tiene que existir.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/xA4XtyjAKJK63Jo8zG4njz/Bono_2..png',
  scale: 1.2,
  label: 'Bono #2',
  title: 'SOS Hormonal: Tu Menú Anticrisis en 5 Minutos',
  description: 'Habrá días difíciles. Este menú de emergencia hormonal fue diseñado para esos días exactos — comidas rápidas, simples y alineadas con lo que tu cuerpo necesita cuando menos energía tienes.',
  bullets: ['Comidas anticrisis listas en 5 minutos o menos', 'Opciones específicas para días de niebla mental', 'Alimentos que estabilizan sin complicar tu día'],
  quote: 'En los días difíciles no necesitas más fuerza de voluntad. Necesitas un plan más simple.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4daWHgzJb95gMad7kD3S9D/Bono_3.png',
  scale: 1,
  label: 'Bono #3',
  title: 'Ritual Matutino: 5 Minutos que Reactivan Tu Vitalidad 50+',
  description: 'La mañana decide el día. Este checklist de 5 minutos te da una secuencia probada para empezar cada mañana con energía e intención — incluso cuando el cuerpo todavía está despertando.',
  bullets: ['Una secuencia matutina de 5 pasos probados', 'Micro-hábitos que activan energía sin esfuerzo extremo', 'Un checklist imprimible para tenerlo siempre a la mano'],
  quote: 'No necesitas más tiempo en la mañana. Necesitas usarlo mejor.'
}];
export const BonusSection = () => {
  return <Section bg="bg-gold/10" data-id="element-13">
      <FadeIn data-id="element-14">
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-15">
          <span className="inline-flex items-center gap-2 text-gold font-bold tracking-wider uppercase text-sm mb-4" data-id="element-16">
            <Gift className="w-4 h-4" data-id="element-17" />
            Solo Por Hoy
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-6 leading-tight whitespace-nowrap" data-id="element-18">
            Los 3 Bonos —{' '}
            <span className="text-gold italic font-normal" data-id="element-19">Gratis Hoy</span>
          </h2>
          <p className="text-lg text-brown-light leading-relaxed" data-id="element-20">
            Cuando te unes hoy, recibes tres recursos adicionales — diseñados
            específicamente para mujeres de 50+ — completamente gratis.
          </p>
          <p className="text-sm text-brown-light/70 italic mt-4" data-id="element-21">
            Valor total combinado:{' '}
            <span className="line-through" data-id="element-22">$141 USD</span>. Tuyos hoy sin costo
            extra.
          </p>
        </div>
      </FadeIn>

      <StaggerContainer className="space-y-12 max-w-5xl mx-auto" data-id="element-23">
        {bonuses.map((bonus, i) => <StaggerItem key={i} data-id="element-24">
            <div className={`bg-white rounded-3xl shadow-md overflow-hidden border border-cream-dark grid md:grid-cols-5 gap-0 ${i % 2 === 1 ? 'md:[&>div:first-child]:order-2' : ''}`} data-id="element-25">
              {/* Image */}
              <div className="md:col-span-2 bg-cream-light flex items-center justify-center p-4 md:p-6" data-id="element-26">
                <div className="w-full aspect-[16/9] rounded-xl shadow-lg overflow-hidden bg-cream-light" data-id="element-27">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-28" />
                </div>
              </div>

              {/* Content */}
              <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center" data-id="element-29">
                <div className="flex items-center gap-3 mb-3 flex-wrap" data-id="element-30">
                  <span className="inline-block bg-coral text-white text-xs font-bold tracking-wider uppercase px-3 py-1 rounded-full" data-id="element-31">
                    {bonus.label}
                  </span>
                  <span className="inline-block bg-sage-light text-sage text-xs font-bold px-3 py-1 rounded-full" data-id="element-32">
                    Valorado en $47 — Gratis hoy
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-bold mb-4 text-brown leading-tight" data-id="element-33">
                  {bonus.title}
                </h3>

                <p className="text-brown-light leading-relaxed mb-5" data-id="element-34">
                  {bonus.description}
                </p>

                <ul className="space-y-2.5 mb-6" data-id="element-35">
                  {bonus.bullets.map((b, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-36">
                      <Check className="w-5 h-5 text-sage mt-0.5 shrink-0" data-id="element-37" />
                      <span className="text-brown-light text-sm leading-relaxed" data-id="element-38">
                        {b}
                      </span>
                    </li>)}
                </ul>

                <div className="bg-cream-light border-l-4 border-gold rounded-r-xl p-4 flex items-start gap-3" data-id="element-39">
                  <Quote className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-40" />
                  <p className="italic text-brown text-sm leading-relaxed" data-id="element-41">
                    {bonus.quote}
                  </p>
                </div>
              </div>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};